export const GET_ORGANIZATION_AGENT_START =
  'GET_ORGANIZATION_AGENT_START';
export const GET_ORGANIZATION_AGENT_SUCCESS =
  'GET_ORGANIZATION_AGENT_SUCCESS';
export const GET_ORGANIZATION_AGENT_ERROR =
  'GET_ORGANIZATION_AGENT_ERROR';
